import { render, staticRenderFns } from "./NewLabel.vue?vue&type=template&id=d6d872c4&scoped=true&"
import script from "./NewLabel.vue?vue&type=script&lang=js&"
export * from "./NewLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d872c4",
  null
  
)

export default component.exports